/*global wp */
import $ from 'jquery';
import Velocity from 'velocity-animate';
import Skrollr from 'skrollr';

const VIDEO_1_DURATION = 8000;
const VIDEO_2_DURATION = 8000;
const VIDEO_3_DURATION = 7000;
const TRANSITION_DURATION = 500;

function initParallax() {
  const s = Skrollr.init({
    forceHeight: false,
    beforerender: (props) => {
      if (props.direction === 'up') {
        return false;
      }
    }
  });

  // Don't do skrollr on mobile
  if (s.isMobile()) {
    s.destroy();
  } else {
    $(window).on('load', s.refresh);
  }
}

function initPortfolioAnimations() {
  const data = [
    {
      title:'Manage Your Portfolios',
      copy: 'Sprout makes it easy to keep track of your goals and see how your investments are growing.',
      label: 'Control Your Goal'
    },
    {
      title: 'Control Your Goal',
      copy: 'Explore the projected growth of a goal and change your contribution at any time.',
      label: 'Customize Risk Tolerance'
    },
    {
      title: 'Customize Risk Tolerance',
      copy: 'Browse through different risk scores and see how they impact your portfolio distribution.',
      label: 'Manage Your Portfolio'
    }
  ];
  let slideIndex = 0;
  const progressbar = $('.wm-portfolios__progress-fill');
  const video = $('.wm-portfolios__video')[0];
  const videoSrc = wp.templateUrl + '/assets/videos/futureof/wm-portfolio-0';
  const button = $('.wm-portfolios__button');

  $('.wm-portfolios__counter-text').text(slideIndex + 1);
  $('.wm-portfolios__title-text').text(data[slideIndex].title);
  $('.wm-portfolios__copy-text').text(data[slideIndex].copy);
  $('.wm-portfolios__button-label').text(data[slideIndex].label);

  function animateStuff() {
    video.play();

    Velocity
      .animate(progressbar, {
        translateX: ['0%', '-100%'],
      }, {
        duration: VIDEO_1_DURATION,
        easing: 'linear',
      }) // fill progress bar
      .then(() => {
        Promise.all([animateInOut()])
          .then(() => {
            setTimeout(animateStuff, TRANSITION_DURATION + 100);
          });
      });
  }

  function animateInOut() {
    slideIndex = (slideIndex + 1) % data.length;
    Velocity
      .animate(progressbar, {
        translateX: ['100%', '0%'],
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic',
      }) // fill progress bar
      .then(() => {
        progressbar.css({ 'transform': 'translateX(-100%)' }); // empty progress bar
      });

    const counterText = $('.wm-portfolios__counter-text');
    const counterTextNext = $('.wm-portfolios__counter-text--next');
    const titleText = $('.wm-portfolios__title-text');
    const titleTextNext = $('.wm-portfolios__title-text--next');
    const copyText = $('.wm-portfolios__copy-text');
    const copyTextNext = $('.wm-portfolios__copy-text--next');
    const buttonLabel = $('.wm-portfolios__button-label');
    const buttonLabelNext = $('.wm-portfolios__button-label--next');
    const videoTransition = $('.wm-portfolios__transition');

    // Animate counter
    Velocity
      .animate(counterText, {
        translateY: ['-100%', '0%'],
        opacity: ['0', '1']

      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        counterText.text(slideIndex + 1);
        counterText.removeAttr('style');
      });
    counterTextNext.text(slideIndex + 1);
    Velocity
      .animate(counterTextNext, {
        translateY: ['0%', '100%'],
        opacity: ['1', '0']

      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        counterTextNext.removeAttr('style');
      });

    // Animate title
    Velocity
      .animate(titleText, {
        translateX: ['-10%', '0%'],
        opacity: ['0', '1']

      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        titleText.text(data[slideIndex].title);
        titleText.removeAttr('style');
      });
    titleTextNext.text(data[slideIndex].title);
    Velocity
      .animate(titleTextNext, {
        translateX: ['0%', '10%'],
        opacity: ['1', '0']

      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        titleTextNext.removeAttr('style');
      });

    // Animate copy
    Velocity
      .animate(copyText, {
        opacity: ['0', '1']
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        copyText.text(data[slideIndex].copy);
        copyText.removeAttr('style');
      });
    copyTextNext.text(data[slideIndex].copy);
    Velocity
      .animate(copyTextNext, {
        opacity: ['1', '0']
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        copyTextNext.removeAttr('style');
      });

    // Animate button label
    Velocity
      .animate(buttonLabel, {
        opacity: ['0', '1']
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        buttonLabel.text(data[slideIndex].label);
        buttonLabel.removeAttr('style');
      });
    buttonLabelNext.text(data[slideIndex].label);
    Velocity
      .animate(buttonLabelNext, {
        opacity: ['1', '0']
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic'
      })
      .then(() => {
        buttonLabelNext.removeAttr('style');
      });

    // Animate transition
    Velocity
      .animate(videoTransition, {
        opacity: ['1', '0'],
        translateX: ['-50%', '-50%'],
        translateY: ['-50%', '-50%'],
      }, {
        duration: (TRANSITION_DURATION / 2),
        easing: 'linear'
      })
      .then(() => {
        // Change video
        video.setAttribute('src', videoSrc + (slideIndex + 1) + '.mp4');
        video.load();

        Velocity
          .animate(videoTransition, {
            opacity: ['0', '1'],
            translateX: ['-50%', '-50%'],
            translateY: ['-50%', '-50%'],
          }, {
            duration: (TRANSITION_DURATION / 2),
            easing: 'linear'
          })
          .then(() => {
          });
      });

    video.pause();
  }

  function clickHandler() {
    Velocity(progressbar, 'stop');
  }

  button.click(clickHandler);
  setTimeout(animateStuff, 1000); // start the loop
}

function initSliderAnimations(containerId, videoName, videoDuration) {
  let slideIndex = 0;
  let previousSlideIndex = 0;
  let clickEvent = false;

  const progressbars = $(containerId + ' .wm-slider__progress-fill');
  const stepButtons = $(containerId + ' .wm-slider__step-button');
  const video = $(containerId + ' .wm-slider__video')[0];
  const videoSrc = wp.templateUrl + '/assets/videos/futureof/' + videoName;

  function animateStuff() {
    const progressbar = progressbars.eq(slideIndex);
    stepButtons.eq(slideIndex).toggleClass('wm-slider__step-button--active');
    video.play();

    Velocity
      .animate(progressbar, {
        translateY: ['0%', '-100%'],
      }, {
        duration: videoDuration,
        easing: 'linear',
      }) // fill progress bar
      .then(() => {
        Promise.all([animateInOut()])
          .then(() => {
            setTimeout(animateStuff, TRANSITION_DURATION + 100);
          });
      });
  }

  function animateInOut() {
    previousSlideIndex = (clickEvent) ? previousSlideIndex : slideIndex;
    slideIndex = (slideIndex + 1) % 3;
    const progressbar = progressbars.eq(previousSlideIndex);
    const stepButton = stepButtons.eq(previousSlideIndex);

    Velocity
      .animate(progressbar, {
        translateY: ['100%', '0%'],
      }, {
        duration: TRANSITION_DURATION,
        easing: 'easeInCubic',
      }) // fill progress bar
      .then(() => {
        progressbar.css({ 'transform': 'translateY(-100%)' }); // empty progress bar
      });

    const videoTransition = $(containerId + ' .wm-slider__transition');

    // Animate transition
    Velocity
      .animate(videoTransition, {
        opacity: ['1', '0'],
        translateX: ['-50%', '-50%'],
        translateY: ['-50%', '-50%'],
      }, {
        duration: (TRANSITION_DURATION / 2),
        easing: 'linear'
      })
      .then(() => {
        // Change video
        video.setAttribute('src', videoSrc + (slideIndex + 1) + '.mp4');
        video.load();
        stepButton.toggleClass('wm-slider__step-button--active');

        Velocity
          .animate(videoTransition, {
            opacity: ['0', '1'],
            translateX: ['-50%', '-50%'],
            translateY: ['-50%', '-50%'],
          }, {
            duration: (TRANSITION_DURATION / 2),
            easing: 'linear'
          })
          .then(() => {
          });
      });

    video.pause();
    clickEvent = false;
  }

  stepButtons.eq(0).click(function() {
    previousSlideIndex = slideIndex;
    slideIndex = 2;
    clickEvent = true;

    Velocity(progressbars.eq(previousSlideIndex), 'stop');
  });
  stepButtons.eq(1).click(function() {
    previousSlideIndex = slideIndex;
    slideIndex = 0;
    clickEvent = true;

    Velocity(progressbars.eq(previousSlideIndex), 'stop');
  });
  stepButtons.eq(2).click(function() {
    previousSlideIndex = slideIndex;
    slideIndex = 1;
    clickEvent = true;

    Velocity(progressbars.eq(previousSlideIndex), 'stop');
  });
  setTimeout(animateStuff, 1000); // start the loop
}

export default {
  init() {
    initParallax();
    initPortfolioAnimations();
    initSliderAnimations('#research', 'wm-research-0', VIDEO_2_DURATION);
    initSliderAnimations('#answers', 'wm-answers-0', VIDEO_3_DURATION);
  },
  finalize() {

  },
};
